import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Heart, ChevronDown, ChevronUp, Minus, Plus, ShoppingBag, Truck, RotateCcw, Ruler } from 'lucide-react';
import Header from './components/Header22';
import Footer from './components/Footer22';

const ProductDetail22 = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [selectedSize, setSelectedSize] = useState('M');
    const [quantity, setQuantity] = useState(1);
    const [selectedImage, setSelectedImage] = useState(0);
    const [wishlisted, setWishlisted] = useState(false);
    const [openAccordion, setOpenAccordion] = useState(null);
    const [hoveredThumb, setHoveredThumb] = useState(null);
    const [hoveredRelated, setHoveredRelated] = useState(null);
    const [relatedWishlist, setRelatedWishlist] = useState({});

    const allProducts = [
        {
            id: 1,
            name: 'Chanderi Silk Saree',
            price: 8999,
            originalPrice: 10999,
            category: 'Chanderi',
            artisan: 'Meena Devi, Master Weaver',
            origin: 'Chanderi, Madhya Pradesh',
            description: 'A luminous Chanderi silk saree handwoven by master artisans of Chanderi. The delicate zari work and gossamer-thin texture make this piece a testament to a 700-year-old weaving tradition. Each saree takes 15-20 days to complete on a traditional pit loom.',
            fabric: '60% Silk, 40% Cotton | Handwoven Chanderi',
            care: 'Dry clean only. Store folded in muslin cloth.',
            images: [
                'https://images.pexels.com/photos/10679171/pexels-photo-10679171.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/6764040/pexels-photo-6764040.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/6764007/pexels-photo-6764007.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/8838890/pexels-photo-8838890.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 2,
            name: 'Block Print Kurta Set',
            price: 4500,
            originalPrice: 5500,
            category: 'Block Print',
            artisan: 'Raju Chippa, Block Printer',
            origin: 'Sanganer, Jaipur',
            description: 'A beautiful block print kurta set crafted using traditional wooden blocks carved by Chippa artisans. Natural vegetable dyes create earthy, skin-friendly hues that deepen with every wash. Each motif is hand-stamped with precision passed through five generations.',
            fabric: '100% Organic Cotton | Hand Block Printed',
            care: 'Machine wash cold separately for first 2 washes. Line dry in shade.',
            images: [
                'https://images.pexels.com/photos/8838890/pexels-photo-8838890.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/8838667/pexels-photo-8838667.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/17611651/pexels-photo-17611651.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/6764040/pexels-photo-6764040.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 3,
            name: 'Khadi Cotton Dupatta',
            price: 2200,
            category: 'Khadi',
            artisan: 'Kamla Ben, Khadi Spinner',
            origin: 'Bhuj, Gujarat',
            description: 'A hand-spun, hand-woven Khadi dupatta embodying the spirit of self-reliance. The natural texture and breathability of Khadi make it perfect for all seasons. Every thread is spun on a charkha by skilled women artisans of Kutch.',
            fabric: '100% Hand-spun Khadi Cotton',
            care: 'Hand wash with mild detergent. Iron on medium heat.',
            images: [
                'https://images.pexels.com/photos/6764040/pexels-photo-6764040.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/10679171/pexels-photo-10679171.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/6764007/pexels-photo-6764007.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/17611651/pexels-photo-17611651.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 4,
            name: 'Banarasi Zari Lehenga',
            price: 15999,
            originalPrice: 19999,
            category: 'Banarasi',
            artisan: 'Ustad Karim, Master Zari Weaver',
            origin: 'Varanasi, Uttar Pradesh',
            description: 'An opulent Banarasi zari lehenga woven by fifth-generation master weavers of Varanasi. The intricate gold zari brocade features traditional motifs including kalga, bel, and jaal patterns. This heirloom piece takes over 30 days to weave on a jacquard loom.',
            fabric: 'Pure Katan Silk with Real Gold Zari',
            care: 'Dry clean only. Store in acid-free tissue paper.',
            images: [
                'https://images.pexels.com/photos/9419032/pexels-photo-9419032.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/11707056/pexels-photo-11707056.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/10679171/pexels-photo-10679171.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/7123307/pexels-photo-7123307.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 5,
            name: 'Chikankari Anarkali',
            price: 6800,
            originalPrice: 8200,
            category: 'Chikankari',
            artisan: 'Naseem Bano, Chikan Artisan',
            origin: 'Lucknow, Uttar Pradesh',
            description: 'A flowing Anarkali adorned with exquisite Chikankari embroidery from Lucknow. Over 36 different stitches create shadow-work and raised patterns on fine cotton. Each piece is hand-embroidered over 2-3 weeks by skilled artisans.',
            fabric: '100% Fine Cotton Cambric | Hand-embroidered',
            care: 'Hand wash in cold water. Iron while slightly damp.',
            images: [
                'https://images.pexels.com/photos/7123307/pexels-photo-7123307.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/9419032/pexels-photo-9419032.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/6764040/pexels-photo-6764040.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/8838890/pexels-photo-8838890.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 6,
            name: 'Handloom Linen Kurta',
            price: 3500,
            category: 'Khadi',
            artisan: 'Bimal Das, Handloom Weaver',
            origin: 'Murshidabad, West Bengal',
            description: 'A contemporary handloom linen kurta woven by artisans of Murshidabad. The naturally textured fabric is breathable and comfortable, perfect for everyday elegance. Supporting this craft helps sustain a community of over 200 weaver families.',
            fabric: '100% Handloom Linen',
            care: 'Machine wash cold. Tumble dry low. Iron on medium.',
            images: [
                'https://images.pexels.com/photos/17611651/pexels-photo-17611651.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/8838890/pexels-photo-8838890.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/6764007/pexels-photo-6764007.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/10679171/pexels-photo-10679171.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 7,
            name: 'Ikat Silk Stole',
            price: 4200,
            category: 'Block Print',
            artisan: 'Padma Rao, Ikat Weaver',
            origin: 'Pochampally, Telangana',
            description: 'A vibrant Ikat silk stole woven using the resist-dyeing technique of Pochampally. Threads are dyed before weaving to create mesmerizing geometric patterns. This GI-tagged craft is recognized by UNESCO as an Intangible Cultural Heritage.',
            fabric: 'Pure Mulberry Silk | Ikat Woven',
            care: 'Dry clean recommended. Store away from direct sunlight.',
            images: [
                'https://images.pexels.com/photos/6764007/pexels-photo-6764007.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/6764040/pexels-photo-6764040.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/10679171/pexels-photo-10679171.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/8838667/pexels-photo-8838667.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 8,
            name: 'Ajrakh Print Dress',
            price: 5800,
            originalPrice: 6800,
            category: 'Block Print',
            artisan: 'Ismail Khatri, Ajrakh Master',
            origin: 'Ajrakhpur, Kutch',
            description: 'A stunning dress featuring Ajrakh block printing, a 4000-year-old craft of Kutch. Natural indigo and madder root dyes create the signature deep blue and red palette. The fabric undergoes 16 stages of washing, dyeing, and printing over 14 days.',
            fabric: '100% Organic Cotton | Natural Dyes',
            care: 'Hand wash separately in cold water. Colours deepen with age.',
            images: [
                'https://images.pexels.com/photos/8838667/pexels-photo-8838667.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/8838890/pexels-photo-8838890.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/6764040/pexels-photo-6764040.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/17611651/pexels-photo-17611651.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
    ];

    const productId = parseInt(id) || 1;
    const product = allProducts.find(p => p.id === productId) || allProducts[0];
    const relatedProducts = allProducts.filter(p => p.id !== product.id).slice(0, 4);

    const sizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

    const accordionItems = [
        {
            title: 'Fabric & Craft Details',
            content: `${product.fabric}\n\nArtisan: ${product.artisan}\nOrigin: ${product.origin}\n\nThis piece carries a heritage authenticity tag verifying its origin, the artisan who crafted it, and the traditional technique employed.`,
        },
        {
            title: 'Size & Fit Guide',
            content: 'Our garments follow standard Indian sizing. For the best fit, we recommend referring to our detailed size chart. If you are between sizes, we suggest going one size up for a comfortable, relaxed fit. For sarees, "Free Size" indicates standard 5.5m length with 0.8m blouse piece. Custom sizing is available upon request.',
        },
        {
            title: 'Care Instructions',
            content: product.care + '\n\nHandcrafted textiles are living fabrics \u2014 slight variations in colour and texture are natural and speak to the authenticity of the craft. These imperfections are part of what makes each piece truly unique.',
        },
        {
            title: 'Shipping & Returns',
            content: 'Free shipping on orders above \u20B92,999. Standard delivery takes 5-7 business days. Handcrafted items may require an additional 3-5 days for quality checks. Exchange within 7 days of delivery. Items must be unworn with all tags intact. Custom-made pieces are non-returnable.',
        },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Cormorant+Infant:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Source+Sans+3:wght@300;400;500;600;700&display=swap');

                .maati-detail-layout {
                    display: flex;
                    flex-direction: column;
                    gap: 32px;
                    padding: 100px 24px 60px;
                    max-width: 1400px;
                    margin: 0 auto;
                }
                @media (min-width: 1024px) {
                    .maati-detail-layout {
                        flex-direction: row;
                        gap: 60px;
                        padding: 120px 48px 80px;
                    }
                }
                .maati-gallery {
                    flex: 1;
                    display: flex;
                    flex-direction: column-reverse;
                    gap: 12px;
                }
                @media (min-width: 1024px) {
                    .maati-gallery {
                        flex-direction: row;
                        position: sticky;
                        top: 100px;
                        height: fit-content;
                    }
                }
                .maati-thumbs {
                    display: flex;
                    gap: 8px;
                }
                @media (min-width: 1024px) {
                    .maati-thumbs {
                        flex-direction: column;
                    }
                }
                .maati-related-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 16px;
                }
                @media (min-width: 768px) {
                    .maati-related-grid {
                        grid-template-columns: repeat(4, 1fr);
                        gap: 24px;
                    }
                }
            `}</style>

            <div style={{ minHeight: '100vh', backgroundColor: '#FAF6F1', fontFamily: "'Source Sans 3', -apple-system, sans-serif" }}>
                <Header cartCount={0} />

                <div className="maati-detail-layout">
                    {/* Gallery */}
                    <div className="maati-gallery" style={{ flex: '1.2' }}>
                        <div className="maati-thumbs">
                            {product.images.map((img, i) => (
                                <div
                                    key={i}
                                    onClick={() => setSelectedImage(i)}
                                    onMouseEnter={() => setHoveredThumb(i)}
                                    onMouseLeave={() => setHoveredThumb(null)}
                                    style={{
                                        width: '72px',
                                        height: '90px',
                                        borderRadius: '6px',
                                        overflow: 'hidden',
                                        cursor: 'pointer',
                                        border: selectedImage === i ? '2px solid #C4572A' : '2px solid transparent',
                                        opacity: hoveredThumb === i || selectedImage === i ? 1 : 0.6,
                                        transition: 'all 0.3s ease',
                                        flexShrink: 0,
                                    }}
                                >
                                    <img src={img} alt={`View ${i + 1}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                </div>
                            ))}
                        </div>
                        <div style={{
                            flex: 1,
                            borderRadius: '12px',
                            overflow: 'hidden',
                            aspectRatio: '3/4',
                            backgroundColor: '#F3ECE4',
                        }}>
                            <img
                                src={product.images[selectedImage]}
                                alt={product.name}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                        </div>
                    </div>

                    {/* Product Info */}
                    <div style={{ flex: '1' }}>
                        {/* Breadcrumb */}
                        <p style={{ fontSize: '13px', color: '#8B7355', marginBottom: '16px' }}>
                            <span style={{ cursor: 'pointer' }} onClick={() => navigate('/template22')}>Home</span>
                            {' / '}
                            <span style={{ cursor: 'pointer' }} onClick={() => navigate('/template22/shop')}>Shop</span>
                            {' / '}
                            <span style={{ color: '#5C3D2E' }}>{product.name}</span>
                        </p>

                        {/* Artisan Badge */}
                        <div style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            backgroundColor: '#F3ECE4',
                            padding: '6px 14px',
                            borderRadius: '20px',
                            marginBottom: '16px',
                        }}>
                            <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#C4572A' }} />
                            <span style={{ fontSize: '12px', fontWeight: 500, color: '#5C3D2E', letterSpacing: '0.5px' }}>
                                {product.artisan}
                            </span>
                        </div>

                        <h1 style={{
                            fontFamily: "'Cormorant Infant', Georgia, serif",
                            fontSize: 'clamp(28px, 4vw, 42px)',
                            fontWeight: 600,
                            color: '#5C3D2E',
                            margin: '0 0 4px 0',
                            lineHeight: 1.2,
                        }}>
                            {product.name}
                        </h1>

                        <p style={{ fontSize: '13px', color: '#8B7355', marginBottom: '20px', fontStyle: 'italic' }}>
                            Origin: {product.origin}
                        </p>

                        {/* Price */}
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px', marginBottom: '24px' }}>
                            <span style={{ fontSize: '28px', fontWeight: 700, color: '#C4572A', fontFamily: "'Cormorant Infant', serif" }}>
                                {'\u20B9'}{product.price.toLocaleString('en-IN')}
                            </span>
                            {product.originalPrice && (
                                <>
                                    <span style={{ fontSize: '18px', color: '#8B7355', textDecoration: 'line-through' }}>
                                        {'\u20B9'}{product.originalPrice.toLocaleString('en-IN')}
                                    </span>
                                    <span style={{
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: '#2E7D32',
                                        backgroundColor: '#E8F5E9',
                                        padding: '2px 10px',
                                        borderRadius: '12px',
                                    }}>
                                        {Math.round((1 - product.price / product.originalPrice) * 100)}% OFF
                                    </span>
                                </>
                            )}
                        </div>

                        <p style={{ fontSize: '15px', color: '#5C3D2E', lineHeight: 1.7, marginBottom: '28px', opacity: 0.85 }}>
                            {product.description}
                        </p>

                        {/* Fabric Tag */}
                        <div style={{
                            backgroundColor: '#F3ECE4',
                            padding: '12px 18px',
                            borderRadius: '8px',
                            marginBottom: '24px',
                            borderLeft: '3px solid #C4572A',
                        }}>
                            <p style={{ fontSize: '13px', fontWeight: 600, color: '#5C3D2E', margin: '0 0 4px 0' }}>Fabric</p>
                            <p style={{ fontSize: '14px', color: '#8B7355', margin: 0 }}>{product.fabric}</p>
                        </div>

                        {/* Size Selector */}
                        <div style={{ marginBottom: '24px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                                <p style={{ fontSize: '14px', fontWeight: 600, color: '#5C3D2E', margin: 0 }}>Size</p>
                                <button style={{
                                    display: 'flex', alignItems: 'center', gap: '4px',
                                    background: 'none', border: 'none', cursor: 'pointer',
                                    fontSize: '13px', color: '#C4572A', fontFamily: "'Source Sans 3', sans-serif",
                                }}>
                                    <Ruler size={14} /> Size Guide
                                </button>
                            </div>
                            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                {sizes.map(size => (
                                    <button
                                        key={size}
                                        onClick={() => setSelectedSize(size)}
                                        style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '8px',
                                            border: selectedSize === size ? '2px solid #C4572A' : '1px solid #E8DDD0',
                                            backgroundColor: selectedSize === size ? '#FFF0EB' : '#FFFFFF',
                                            color: selectedSize === size ? '#C4572A' : '#5C3D2E',
                                            fontFamily: "'Source Sans 3', sans-serif",
                                            fontSize: '14px',
                                            fontWeight: 500,
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                        }}
                                    >
                                        {size}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Quantity */}
                        <div style={{ marginBottom: '28px' }}>
                            <p style={{ fontSize: '14px', fontWeight: 600, color: '#5C3D2E', margin: '0 0 12px 0' }}>Quantity</p>
                            <div style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                border: '1px solid #E8DDD0',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                backgroundColor: '#FFFFFF',
                            }}>
                                <button
                                    onClick={() => setQuantity(q => Math.max(1, q - 1))}
                                    style={{
                                        width: '44px', height: '44px', border: 'none',
                                        backgroundColor: 'transparent', cursor: 'pointer',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        color: '#5C3D2E',
                                    }}
                                >
                                    <Minus size={16} />
                                </button>
                                <span style={{
                                    width: '48px', textAlign: 'center',
                                    fontSize: '16px', fontWeight: 600, color: '#5C3D2E',
                                    borderLeft: '1px solid #E8DDD0', borderRight: '1px solid #E8DDD0',
                                    lineHeight: '44px',
                                }}>
                                    {quantity}
                                </span>
                                <button
                                    onClick={() => setQuantity(q => q + 1)}
                                    style={{
                                        width: '44px', height: '44px', border: 'none',
                                        backgroundColor: 'transparent', cursor: 'pointer',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        color: '#5C3D2E',
                                    }}
                                >
                                    <Plus size={16} />
                                </button>
                            </div>
                        </div>

                        {/* CTA Buttons */}
                        <div style={{ display: 'flex', gap: '12px', marginBottom: '32px', flexWrap: 'wrap' }}>
                            <button
                                onClick={() => navigate('/template22/cart')}
                                style={{
                                    flex: 1,
                                    minWidth: '200px',
                                    padding: '16px 32px',
                                    backgroundColor: '#C4572A',
                                    color: '#FFFFFF',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontFamily: "'Source Sans 3', sans-serif",
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    letterSpacing: '1px',
                                    textTransform: 'uppercase',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '10px',
                                    transition: 'all 0.3s ease',
                                }}
                                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#D4683B'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#C4572A'; }}
                            >
                                <ShoppingBag size={18} /> Add to Cart
                            </button>
                            <button
                                onClick={() => setWishlisted(!wishlisted)}
                                style={{
                                    width: '52px',
                                    height: '52px',
                                    borderRadius: '8px',
                                    border: '1px solid #E8DDD0',
                                    backgroundColor: wishlisted ? '#FFF0EB' : '#FFFFFF',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.3s ease',
                                }}
                            >
                                <Heart size={20} fill={wishlisted ? '#C4572A' : 'none'} color="#C4572A" />
                            </button>
                        </div>

                        {/* Trust Badges */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, 1fr)',
                            gap: '12px',
                            padding: '20px',
                            backgroundColor: '#F3ECE4',
                            borderRadius: '10px',
                            marginBottom: '32px',
                        }}>
                            {[
                                { icon: Truck, label: 'Free Shipping', sub: 'Above \u20B92,999' },
                                { icon: RotateCcw, label: 'Easy Exchange', sub: 'Within 7 days' },
                                { icon: ShoppingBag, label: 'Handcrafted', sub: 'Artisan made' },
                            ].map((badge, i) => (
                                <div key={i} style={{ textAlign: 'center' }}>
                                    <badge.icon size={20} color="#C4572A" style={{ margin: '0 auto 6px' }} />
                                    <p style={{ fontSize: '12px', fontWeight: 600, color: '#5C3D2E', margin: '0 0 2px 0' }}>{badge.label}</p>
                                    <p style={{ fontSize: '11px', color: '#8B7355', margin: 0 }}>{badge.sub}</p>
                                </div>
                            ))}
                        </div>

                        {/* Accordion */}
                        <div style={{ borderTop: '1px solid #E8DDD0' }}>
                            {accordionItems.map((item, i) => (
                                <div key={i} style={{ borderBottom: '1px solid #E8DDD0' }}>
                                    <button
                                        onClick={() => setOpenAccordion(openAccordion === i ? null : i)}
                                        style={{
                                            width: '100%',
                                            padding: '18px 0',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            fontFamily: "'Source Sans 3', sans-serif",
                                            fontSize: '15px',
                                            fontWeight: 600,
                                            color: '#5C3D2E',
                                        }}
                                    >
                                        {item.title}
                                        {openAccordion === i ? <ChevronUp size={18} color="#8B7355" /> : <ChevronDown size={18} color="#8B7355" />}
                                    </button>
                                    {openAccordion === i && (
                                        <div style={{
                                            paddingBottom: '18px',
                                            fontSize: '14px',
                                            color: '#8B7355',
                                            lineHeight: 1.7,
                                            whiteSpace: 'pre-line',
                                        }}>
                                            {item.content}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Related Products */}
                <section style={{ maxWidth: '1400px', margin: '0 auto', padding: '40px 24px 80px' }}>
                    <h2 style={{
                        fontFamily: "'Cormorant Infant', Georgia, serif",
                        fontSize: '32px',
                        fontWeight: 500,
                        color: '#5C3D2E',
                        textAlign: 'center',
                        marginBottom: '40px',
                    }}>
                        You May Also Love
                    </h2>
                    <div className="maati-related-grid">
                        {relatedProducts.map(rp => (
                            <div
                                key={rp.id}
                                onClick={() => {
                                    navigate(`/template22/product/${rp.id}`);
                                    window.scrollTo(0, 0);
                                }}
                                onMouseEnter={() => setHoveredRelated(rp.id)}
                                onMouseLeave={() => setHoveredRelated(null)}
                                style={{
                                    backgroundColor: '#FFFFFF',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    cursor: 'pointer',
                                    transition: 'all 0.4s ease',
                                    boxShadow: hoveredRelated === rp.id ? '0 12px 40px rgba(92,61,46,0.12)' : '0 2px 12px rgba(92,61,46,0.06)',
                                    transform: hoveredRelated === rp.id ? 'translateY(-4px)' : 'none',
                                    border: '1px solid #E8DDD0',
                                }}
                            >
                                <div style={{ position: 'relative', aspectRatio: '3/4', overflow: 'hidden' }}>
                                    <img
                                        src={rp.images[0]}
                                        alt={rp.name}
                                        style={{
                                            width: '100%', height: '100%', objectFit: 'cover',
                                            transition: 'transform 0.6s ease',
                                            transform: hoveredRelated === rp.id ? 'scale(1.05)' : 'scale(1)',
                                        }}
                                    />
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setRelatedWishlist(prev => ({ ...prev, [rp.id]: !prev[rp.id] }));
                                        }}
                                        style={{
                                            position: 'absolute', top: '10px', right: '10px',
                                            width: '32px', height: '32px', borderRadius: '50%',
                                            backgroundColor: 'rgba(255,255,255,0.9)', border: 'none',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <Heart size={14} fill={relatedWishlist[rp.id] ? '#C4572A' : 'none'} color="#C4572A" />
                                    </button>
                                </div>
                                <div style={{ padding: '14px' }}>
                                    <h3 style={{
                                        fontFamily: "'Cormorant Infant', Georgia, serif",
                                        fontSize: '16px', fontWeight: 600, color: '#5C3D2E',
                                        margin: '0 0 6px 0',
                                    }}>
                                        {rp.name}
                                    </h3>
                                    <p style={{ fontSize: '15px', fontWeight: 600, color: '#C4572A', margin: 0 }}>
                                        {'\u20B9'}{rp.price.toLocaleString('en-IN')}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <Footer />
            </div>
        </>
    );
};

export default ProductDetail22;
